import styled from 'styled-components';
import { selectColor } from '@panel/commons';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;

const TitleStyled = styled.div`
  height: 31px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  line-height: 130%;
  white-space: break-spaces;
`;

const SubtitleStyled = styled.div`
  width: 100%;
  min-height: 22px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  line-height: 22px;
  color: ${selectColor('grayDarkLight')};
  margin-top: 8px;
  white-space: break-spaces;
`;

export { Container, TitleStyled, SubtitleStyled };
